import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import TextField from '@mui/material/TextField';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import InputAdornment from '@mui/material/InputAdornment';

import { CardActionArea } from '@mui/material';

import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { createTheme, ThemeProvider } from '@mui/material/styles';


import { urls } from '../config.js'
import { formLabelClasses } from '@mui/material';
import moment from 'moment';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import SearchIcon from '@mui/icons-material/Search';
import PageNav from '../components/PageNav.js';

const persIcon = <PersonIcon fontSize="" />

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];


function Homepage() {

  const [query, setQuery] = useState('');
  const [data, setData] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initial, setInitial] = useState(true);
  const [notFound, setNotFound] = useState(false);

  document.title = "Search Twitch Clips"

  const navigate = useNavigate()
  const openLink = url => {
    navigate(url);
    
  };

  const fetchData = async () => {
    let string = `${urls.homepageView}`
    const data = await fetch(string);
    // convert the data to json
    const json = await data.json();

    // set state with the result
    if (json.error !== undefined) {
      setNotFound(true)
      setLoading(false)

    }
    else {
      setData(json)
      setVideos(json.threeVideos)
      setLoading(false)
    }
  };

  useEffect(() => {
    if (initial == true) {
      // call the function
      fetchData()
      // eslint-disable-next-line
      setInitial(false)
    }
  }, []);




  const handleKeyDown = (event) => {
    if (event.key === 'Enter')
      navigate(`/search?q=${query}`)


  }


  const safeUserData = () => {
    setQuery(document.getElementById('outlined-basic\ query').value);

  }


  return (
    <>
    {loading ? 
    <div id="homePageLoading">
    <CircularProgress color="inherit"/>
    </div> :
    <>
        {/* Hero unit */}
        <Box
          sx={{
            bgcolor: 'background.paper',
            pt: 8,
            pb: 6,
          }}
        >
          <Container maxWidth="sm">
            <Typography
              component="h1"
              variant="h2"
              align="center"
              color="text.primary"
              gutterBottom
            >
              The world's largest library of Twitch clips
            </Typography>
            <Typography variant="h5" align="center" color="text.secondary" paragraph>
              {new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(data.total)} clips, ready to be searched and discovered
            </Typography>
            <Stack
              spacing={1}
              justifyContent="center"
            >
              <TextField id="outlined-basic query" label="Search" variant="outlined" onChange={() =>
                safeUserData()
              } onKeyDown={handleKeyDown} InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }} />
            </Stack>
          </Container>
        </Box>
        <Container maxWidth="lg">

          <Grid container justifyContent="center" spacing={2} columnGap={3} rowGap={3} columns={{ xs: 3, sm: 8, md: 10 }} marginTop={2} marginBottom={2}>

            {/* End hero unit */}
            {Array.from(videos).map((video, index) => {

              let tagString = String(`
${video.broadcaster_name}
`)



              return (
                <Grid xs={1} sm={2} md={3} rowSpacing={1} key={index} >
                  <item>
                    <Card onClick={() => window.open(`https://clips.twitch.tv/${video.id}`, '_blank')}>
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          image={video.thumbnail_url}
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h5" component="div" id="videoTitle" style={{ fontSize: 17 }}>
                            {video.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {persIcon}
                            {tagString}
                            <br />
                            <AccessTimeFilledIcon fontSize="" />  {" "}
                            {moment(video.created_at).fromNow()}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </item>
                </Grid>
              )
            })}
          </Grid>
        </Container>

    </>
}
</>
  );
}

export default Homepage